
export enum EncoderType {
  AE = 'AE',
  VDA = 'VDA',
}

const SELECTED_ENCODER_LOCAL_STORAGE_KEY = 'selectedEncoder';
const SELECTED_ENCODER_DO_NOT_REMIND_VALUE = 'ignore';

export class Encoder {
    id: number
    code: string
    ipAddress: string
    ipPort: number
    requestTimeoutSeconds: number
    requestIntervalMiliSeconds: number
    readingLoopTimeoutSeconds: number
    sleepBetweenCardsMiliSeconds: number
    type: EncoderType

    public static getEncoderDataFromStorage(): Encoder {
      const storedEncoder: Encoder = JSON.parse(localStorage.getItem(SELECTED_ENCODER_LOCAL_STORAGE_KEY));
      return storedEncoder;
    }

    public static setEncoderDataToStorage(encoder: Encoder) {
      localStorage.setItem(SELECTED_ENCODER_LOCAL_STORAGE_KEY, JSON.stringify(encoder));
    }

    public static ignoreSelection() {
      localStorage.setItem(SELECTED_ENCODER_LOCAL_STORAGE_KEY, JSON.stringify({id: SELECTED_ENCODER_DO_NOT_REMIND_VALUE}));
    }

    public static selectionIsIgnored(storedEncoder: Encoder): boolean {
      return storedEncoder?.id.toString() === SELECTED_ENCODER_DO_NOT_REMIND_VALUE
    }
}
